<template>
  <form novalidate :disabled="loadingData" @submit.prevent="() => {}">
    <v-row no-gutters>
      <v-col cols="8">
        <v-card max-width="1200px" flat color="transparent">
          <v-card-title>
            <FormHeader
              :loading="loading"
              :link="'page-info-pages'"
              :title="getTitle ? `${getTitle} статья помощи` : `Создать статью помощи`"
            />
          </v-card-title>
          <v-card-text>
            <PageContent height="90">
              <v-container>
                <InputTitleSlug
                  :is-loading="loading"
                  :title="fields.name"
                  :title-error="validationErrors.name"
                  :slug="fields.slug"
                  :slug-error="validationErrors.slug"
                  :isSlugEnabled="!isNew"
                  @change:title="fields.name = $event"
                  @change:slug="fields.slug = $event"
                  @input:slug="$v.fields.slug.$touch"
                />
                <v-row>
                  <v-col cols="12">
                    <span>Анонс (<TranslationIcon />)</span>
                    <v-text-field outlined :disabled="loading" v-model="fields.excerpt" />
                  </v-col>
                </v-row>
                <v-row>
                  <span>Контент (<TranslationIcon />)</span>
                  <QuillEditorVue
                    :cols="12"
                    :title="''"
                    :content="fields.content"
                    :disabled="loading"
                    :loading="loading"
                    light-mode
                    @input="fields.content = $event"
                    @onChangeContent="$emit('change:contentForMobile', { fields, $event })"
                  />
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <SeoSettings
                      :data="data"
                      :loading="loading"
                      @on-input-seo="fields = Object.assign({}, fields, $event)"
                    />
                  </v-col>
                </v-row>
                <v-col cols="12" class="mt-10">
                  <span>Категории статей помощи</span>
                  <v-list v-if="categories.length > 0">
                    <v-list-group v-for="category in categories" :key="category.id">
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ category.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                      <v-list-item v-for="child in category.children" :key="child.id">
                        <v-list-item-content>
                          <v-list-item-title class="ml-3">
                            {{ child.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-checkbox
                            v-if="isNew"
                            @click.stop="chencgeCategory(child.id)"
                          ></v-checkbox>
                          <v-checkbox
                            v-else-if="!!data"
                            :input-value="
                            !!data.infoCategories.find(
                              category => category.id === child.id
                            )
                          "
                            @click.stop="chencgeCategory(child.id)"
                          ></v-checkbox>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list-group>
                  </v-list>
                </v-col>
              </v-container>
            </PageContent>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <ManageSidePanel
          v-if="isNew"
          ref="manageSidePanel"
          isShowSortOrder
          :is-new="isNew"
          :is-loading="loading"
          :language="language"
          :translations="fields.translations"
          :sortOrder="fields.sortOrder"
          @cancel="$router.push({ name: 'page-info-pages' })"
          @submit="submit"
          @update-translations="Object.assign(fields.translations, $event)"
          @language-update="$emit('language-update', $event)"
          @update-sort-order="fields.sortOrder = Number($event)"
        >
          <template #info-append>
            <StatusPicker
              align="center"
              cols="12"
              title="Статус:"
              :disabled="loading"
              :loading="loading"
              :status="fields.status"
              @status:change="fields.status = $event"
            />
          </template>
        </ManageSidePanel>
        <ManageSidePanel
          v-else-if="!!data"
          ref="manageSidePanel"
          isShowSortOrder
          :is-new="!data.id"
          :created-at="data.createdAt"
          :updated-at="data.updatedAt"
          :is-loading="loading"
          :language="language"
          :translations="fields.translations"
          :entity-id="data.id"
          :entity-type="'infoPage'"
          :sortOrder="fields.sortOrder"
          @delete="$emit('delete-info-page')"
          @cancel="$router.push({ name: 'page-info-pages' })"
          @submit="submit"
          @update-translations="Object.assign(fields.translations, $event)"
          @language-update="$emit('language-update', $event)"
          @update-sort-order="fields.sortOrder = Number($event)"
        >
          <template #info-append>
            <StatusPicker
              align="center"
              cols="12"
              title="Статус:"
              :disabled="loading"
              :loading="loading"
              :status="fields.status"
              @status:change="fields.status = $event"
            />
            <v-row v-if="!isNew" align="center">
              <v-col cols="6">
                <span>Посмотреть на сайте</span>
              </v-col>
              <v-col cols="6">
                <v-btn
                  icon
                  link
                  color="primary"
                  target="_blank"
                  :href="redirerectToWebPortal"
                  :loading="loading"
                  ><v-icon>mdi-web</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </template>
        </ManageSidePanel>
      </v-col>
    </v-row>
  </form>
</template>
<script>
import FormAbstract from '@/components/abstract/form'
import ManageSidePanel from '@/components/manage-side-panel'
import validationRules from './validation-rules.js'
import SeoSettings from '@/components/seo-settings'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import validationTranslations from '@/mixins/translations/validationTranslations.mix.js'
import prepareTranslations from '@/mixins/translations/prepareTranslations.mix'
import FormHeader from '@/components/form-header'
import InputTitleSlug from '@/components/inputs/InputTitleSlug'
import QuillEditorVue from '@/components/quill-editor'
import { mixForm } from '@/utils/form.mix.js'
import StatusPicker from '@/components/status-picker'
import PageContent from '@/components/page-content/PageContent.vue'

export default {
  extends: FormAbstract,
  mixins: [validationTranslations, prepareTranslations, mixForm],
  name: 'FormInfoPage',
  validationRules,
  props: {
    data: {
      type: Object,
      default: null
    },
    isNew: {
      type: Boolean,
      default: true
    },
    loadingData: {
      type: Boolean,
      default: false
    },
    language: {
      type: String,
      default: null
    },
    infoCategories: {
      type: Array,
      default: null
    }
  },
  components: {
    PageContent,
    InputTitleSlug,
    TranslationIcon,
    ManageSidePanel,
    SeoSettings,
    FormHeader,
    QuillEditorVue,
    StatusPicker
  },
  data () {
    return {
      fields: {
        name: null,
        slug: undefined,
        excerpt: '',
        content: '',
        infoCategories: [],
        seoMetaTitle: null,
        seoMetaDescription: null,
        seoDisallowIndex: false,
        seoMetaKeywords: null,
        seoRelCanonical: null,
        seoOgImage: null,
        status: null,
        translations: { ru: { isEnabled: true } }
      }
    }
  },
  computed: {
    redirerectToWebPortal () {
      if (this.infoCategories && this.data) {
        // find child category

        const childCategory = this.data?.infoCategories[0]?.id
          ? this.infoCategories?.find(
            category => category?.id === (this.data?.infoCategories[0]?.id || null)
          ) || null
          : null

        // find parentCategory
        const parentId = childCategory ? childCategory?.parentId : null
        const parentCategory = parentId
          ? this.infoCategories?.find(category => category?.id === parentId)?.slug || null
          : null

        const { slug } = this.data
        return window.location.href.includes('demo')
          ? `${process.env.VUE_APP_WEB_PORTAL_URL_DEMO}/help/${parentCategory}/${childCategory?.slug}/${slug}`
          : `${process.env.VUE_APP_WEB_PORTAL_URL}/help/${parentCategory}/${childCategory?.slug}/${slug}`
      }
      return '#'
    },
    categories () {
      if (this.infoCategories === null) return []
      const output = []
      // recursion can be added here
      this.infoCategories.forEach(item => {
        // find and add all children
        const children = this.infoCategories.filter(child => child.parentId === item.id)
        if (children.length) children.forEach(child => item.children.push(child))
        // category (parent)
        if (item.parentId === null) output.push(item)
      })
      return output
    },
    getTitle () {
      if (this.data) {
        return this.data?.name || ''
      }
      return null
    },
    validationRulesVars () {
      return { id: this.data?.id, ctx: this, isNew: this.isNew }
    }
  },
  watch: {
    data (val) {
      this.populate(val)
    }
  },
  methods: {
    async submit () {
      const isValid = await this.validate()
      if (!isValid) {
        this.mixScrollToError(this.$v)
        return
      }
      if (!this.mixIsValidTranslations(this.fields.translations)) {
        this.$errorMsg('Не выбран ни один язык для контента!')
        return
      }
      const payload = {
        ...this.composeFormData(this.fields)
      }
      payload.infoCategories =
        payload?.infoCategories?.map(category => category.id) || null
      delete payload.seoOgImage
      this.mixPrepareTranslations(payload)
      if (this.$v.fields.$model.infoCategories.length > 0) {
        this.$emit('submit', payload)
      } else {
        this.$errorMsg('Не выбрана ни одна из категорий статей помощи!')
      }
    },
    chencgeCategory (categoryId) {
      if (!this.fields.infoCategories.find(category => category.id === categoryId)) {
        this.fields.infoCategories.push({ id: categoryId })
      } else {
        this.fields.infoCategories = this.fields.infoCategories.filter(
          category => category.id !== categoryId
        )
      }
    }
  }
}
</script>
